import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TransferCaseCommonFunction } from '../transfer-functions';
import { PartnerTransferCase, TransferCaseData, TransferCaseInputCase } from '../transfer-models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { Router } from '@angular/router';
import { ClickPreventer } from 'app/shared/utilities/developHelpers';
import { SubscriptionObject } from 'app/shared/models/standard.models';

@Component({
  selector: 'transfer-os-case',
  templateUrl: './transfer-os-case.component.html',
  styleUrls: ['./transfer-os-case.component.css']
})
export class TransferOsCaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() case: TransferCaseInputCase;
  @Input() openModal = false;
  @Input() type: string;
  @Output() update = new EventEmitter();
  @Output() reload = new EventEmitter();

  caseType: 'case' | 'partner' | 'partnerCase' | 'partnerOffer' | 'email';
  integrationId = '58ecfda6-79a6-4507-80ac-29b6d025360b';
  integrationType; // if true then can transfer to OS (has Udbakke module, checked onInit)
  subscriptions: SubscriptionObject = {};
  f = new TransferCaseCommonFunction(this.http);

  partnerCase: PartnerTransferCase;
  
  osTypes;
  osStatuses;
  osEconomyGroups;
  osDepartments;
  osCustomerGroups;

  updating = false;
  
  customerStep = 'final';
  customerAction;
  standardSettings;
  reject = false;
  cancel = false;
  data = new TransferCaseData();
  nico = new ClickPreventer();

  constructor(private http:HttpClient,private sharedData: SharedDataService, private router:Router) { }

  ngOnInit(): void {
    let guards = JSON.parse(localStorage.getItem('guards'));
    this.integrationType = !!guards.find((x:{ name:string }) => x.name == 'Udbakke Light') ? false: !!guards.find(x => x.name == 'Udbakke') ? true : null;
    this.subscriptions['companyInfo'] = this.sharedData.companyInformation().subscribe((data)=> this.f.companyInfo = data);
    this.subscriptions['responsibles'] = this.sharedData.responsibles().subscribe((data)=> this.f.responsibles = data);
    this.subscriptions['fitters'] = this.sharedData.fitter().subscribe((data)=> this.f.fitters = data);
    this.subscriptions['companyUsers'] = this.sharedData.companyUsers().subscribe((data)=> this.f.companyUsers = data?.filter(x => !!x.externalId));

    this.getTypes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.case && !!changes.case.currentValue || !!changes.openModal && !!changes.openModal.currentValue){
      this.reset();
      this.checkCaseType(changes.case.currentValue);
      document.getElementById('transferCaseModalOpener').click();
    }
  }

  ngOnDestroy(): void {
    for (let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  checkCaseType(c) {
    if(!!c.transferTypeId){ this.caseType = 'email' }
    else if(!!c.caseId) { this.caseType = 'case' }
    else { 
      if(c.transferId) this.f.getPartnerCase(c.transferId).subscribe((data: PartnerTransferCase) => {
        //console.log('Partner Case',data)
        /*
          PartnerCase and PartnerOffer both lack invoice data in the TransferCaseInputCase, so it will be added when loading the partner case.
        */
        this.case.invoice = {...data.invoice, id: null};
        this.partnerCase = data;
        this.caseType = !!this.partnerCase.isOfferRequest ? 'partnerOffer' : 'partnerCase';
      });
    }
  }

  getTypes() {
    this.f.getOSTypes().subscribe((data: any) => { this.osTypes = data.sort((a, b) => a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1) });
    this.f.getOSStatus().subscribe((data) => { this.osStatuses = data; });
    this.f.getOSEconomyGroups().subscribe((data) => { this.osEconomyGroups = data });
    this.f.getOSDepartments().subscribe((data) => { this.osDepartments = data; });
    this.f.getOSCustomerGroups().subscribe((data: any[]) => { this.osCustomerGroups = data.sort((a, b) => a.id < b.id ? -1 : 1) });
  }

  documentAddressChange(event) {
    if(!!event.action){
      switch(this.caseType){
        case 'case':{
          break
        }
        case 'partnerCase':{
          /*
          convert customer address to partner case data.
          */
         this.case = this.f.addressToPartnerCaseAddress(event, this.case);
          ;break
        }
      }
    }
    else if(!!event.currentStep) this.customerStep = event.currentStep;
  }

  goToCase() {
    this.router.navigateByUrl("/Details/" + this.case.caseId);
  }

  setParentId(event) {
    this.data.parentCaseId = event.caseId;
  }

  reset() {
    let c = this.case;
    this.data = {
      ...new TransferCaseData(), 
      integrationId: this.integrationId, 
      caseId: c.caseId,
      responsibleId: c.responsible,
      osDepartmentId: null,
      osStatus: !!this.osStatuses && this.osStatuses.length > 0 ? 99991 :  null,
      customerGroupId: !!this.osCustomerGroups && this.osCustomerGroups.length > 0 ?  this.osCustomerGroups[0].id : null,
      economySystemGroupId: null,
      parentCaseId: null,
      foremanId: null,
      caseTypeId: null
    }
    this.partnerCase = null;
    this.openModal = false;
    this.reject = false;
    this.customerStep = 'final';
    this.customerAction = null;
    // createdCaseId ? 
    
  }

  addMessageToCase(c: any) {
    // if a caseId is provided, send as message on caseId, then remove case from transfers
    // to test send mail to [ companyId ]@mail.jublo.dk
    this.f.messageToCase(c.caseId, this.case.description, this.case.title).subscribe(
      (data)=> {
        /*
        Message has been transfered to the case.
        The modal will close when output case has been rejected.
        Component has to refresh the outbox.
        */
      this.f.rejectCase(this.case.transferId).subscribe(
        ()=> {
          document.getElementById('transferCaseCloseModalBtn').click();
          this.update.emit('mailSentToCase');
        }
      )
      },
      err => console.log('Error occurred while transfering message to case')
    )
  }

  async accept(send:boolean) {
    /*
    All data need to be saved before starting.
    */
    switch(this.caseType) {
      case 'case':{
        /*
        Data should be validated in order to press this button.
        Case data is first updated.
        Then it is transferred to ERP and outbox is updated.
        */
       let c = this.case;
       let d = await this.validateERP();
       this.f.editCase(c.caseId,c.title,c.description,c.requisitionNumber,c.reference, c.internalNote).subscribe(
        ()=> {
          this.f.transferCase(d).subscribe(
            data => this.update.emit('caseAccepted')
           )
        }
       )
       
       break
      }
      case 'partnerCase':{
        let data = this.f.inputToOutputCase(this.case); // works as validation for creation of a jublo case. Not used yet.
        data.caseTypeId = '1dc53948-194c-4ec0-8905-ed11e3bbdca2';
        let d = await this.validateERP();
        this.f.acceptCaseTransfer(this.case.transferId, data).subscribe(
          (caseId:string)=>{
            d.caseId = caseId;
            /*
            Case has been created and caseId has been returned.
            */
            if(send){
              this.f.transferCase(d).subscribe(() => this.update.emit('partnerCaseTransferred') )
            }
            else this.update.emit('partnerCaseAccepted')
            
          })
        break
        }
      case 'partnerOffer':{
        let data = this.f.inputToOutputCase(this.case); // works as validation for creation of a jublo case. Not used yet.
        let d = await this.validateERP();
        this.f.acceptCaseTransfer(this.case.transferId, data).subscribe(
          (caseId:string)=>{
            d.caseId = caseId;
            /*
            Case has been created and caseId has been returned. Could be used to link user to the offer.
            No transfer to the ERP.
            */
            this.update.emit('partnerOfferAccepted')
          }
        )
       break
      }
      case 'email':{
        let data = this.f.inputToOutputCase(this.case); // works as validation for creation of a jublo case. Not used yet.
        let d = await this.validateERP();
        this.f.acceptCaseTransfer(this.case.transferId, data).subscribe(
          (caseId:string)=>{
            d.caseId = caseId;
            /*
            Case has been created and caseId has been returned.
            */
            if(send){
              this.f.transferCase(d).subscribe(() => this.update.emit('emailCaseTransferred') )
            }
            else this.update.emit('emailCaseAccepted');
          })
       break
      }
    }
  }

  rejectCase() {
    this.f.rejectCase(this.case.transferId).subscribe(() => {
      document.getElementById('transferCaseCloseModalBtn').click();
      this.update.emit('caseRejected');
    });
  }

  cancelCase() {
    this.f.cancelCase(this.case.caseId).subscribe(() => {
      document.getElementById('transferCaseCloseModalBtn').click();
      this.update.emit('caseRejected');
    });
  }

  editCase() {
    if(this.caseType == 'case') {
      let c = this.case;
      this.f.editCase(c.caseId,c.title,c.description,c.requisitionNumber, c.reference, c.internalNote).subscribe(()=>{})
    }
  }

  async validateERP():Promise<TransferCaseData>{
    let c = this.case;
    return {
      caseId: c.caseId,
      integrationId: this.integrationId,
      caseTypeId: this.data.caseTypeId,
      customerGroupId: this.data.customerGroupId,
      economySystemGroupId: this.data.economySystemGroupId,
      parentCaseId: this.data.parentCaseId,
      minubaCaseType: null,
      responsibleId: c.responsible,
      foremanId: this.data.foremanId,
      eOrderGroupId: null,
      eDimensionCarrierId: null,
      eDimensionDepartmentId: null,
      ePriceGroupId: null,
      eProfitGroupId: null,
      eDimensionPurposeId: null,
      eProjectType: null,
      osDepartmentId: !!this.data.osDepartmentId ? +this.data.osDepartmentId : null,
      osStatus: this.data.osStatus
    }
  }
}

